
import router from '@/router';
import store from '@/store';
import sheet from './sheet.vue';

export default {
    install(Vue) {
        const Constructor = Vue.extend(sheet).extend({ store, router });
        const instance = new Constructor();

        /*
         ** template <= 加载组件
         ** props <= 组件内调用函数传参
         ** zone <= 加载区域
         ** bodyCanMove <= sheet 的 body 区域是否可以滚动
         */
        Vue.prototype.$sheet = ({
            template = null,
            props = {},
            zone = 'body',
            bodyCanMove = true,
        }) => {
            instance.$mount(document.createElement('div'));

            instance.visible = false;
            instance.visible2 = false;

            if (zone === 'swipebar') {
                document.body
                    .querySelector('.swipebar-inner')
                    .appendChild(instance.$el);
            } else {
                // document.body.appendChild(instance.$el);
                document.body.querySelector('.app').appendChild(instance.$el);
            }

            instance.bodyCanMove = bodyCanMove;

            instance.visible = true;
            instance.animate = true;

            setTimeout(() => {
                instance.visible2 = true;
            }, 50);

            instance.$root.$options.components = {
                templateModal: template,
            };

            instance.propsParams = props;

            return new Promise((resolve, reject) => {
                instance.promiseStatus = { resolve, reject };
            });
        };

        Vue.prototype.$hideSheet = () => {
            instance.visible2 = false;
            setTimeout(() => {
                instance.visible = false;
                instance.animate = false;
            }, 50);
        };
    },
};
